import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import { IFavoriteButtonProps } from '../../../types/newbuilding/favorite';

export function FavoriteButton({ isFavorite, onClick, theme = 'fill_secondary' }: IFavoriteButtonProps) {
  const icon = isFavorite ? (
    <IconToggleHeartOn16 color="icon-negative-default" />
  ) : (
    <IconToggleHeartOff16 color="icon-negative-default" />
  );
  const label = isFavorite ? 'В избранном' : 'В избранное';

  return (
    <Button theme={theme} onClick={onClick} beforeIcon={icon} size="XS">
      {label}
    </Button>
  );
}
